import { connect } from "react-redux";

// Constants
import { sections } from "src/constants";

// Component
import { CheckboxFilterComponent } from "src/components/filters";

// Selectors
import { locationsFilterConfigSelector } from "src/selectors/ui_config_selectors/global";
import { createSectionSelectors } from "src/ui_processors/global/selector_creators";

// Actions
import { createSectionActions } from "src/ui_processors/global/action_creators";

const sectionSelectors = createSectionSelectors(sections.monitoring);
const sectionActions = createSectionActions(sections.monitoring);

// State
function mapStateToProps(state) {
  return {
    filterConfig: locationsFilterConfigSelector(state),
    filterCheckedState: sectionSelectors.createFilterCheckedStateSelector(
      locationsFilterConfigSelector(state)
    )(state)
  };
}

// Dispatch Actions
function mapDispatchToProps(dispatch) {
  return {
    selectCheckbox: filterObject => {
      dispatch(sectionActions.selectCheckbox(filterObject));
    },
    deselectCheckbox: filterObject => {
      dispatch(sectionActions.deselectCheckbox(filterObject));
    }
  };
}

export const SideBarLocationsFilterContainerMonitoring = connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckboxFilterComponent);
